class FacetFiltersForm extends HTMLElement {
    constructor() {
        super(),
            (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
            (this.isLoading = !1),
            (this.debouncedOnSubmit = debounce((event) => {
                this.isLoading || this.onSubmitHandler(event);
            }, 800)),
            this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
    }
    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
            searchParams !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(searchParams, null, !1);
        };
        window.addEventListener("popstate", onHistoryChange);
    }
    static toggleActiveFacets(disable = !0) {
        document.querySelectorAll(".js-facet-remove").forEach((element) => {
            element.classList.toggle("disabled", disable);
        });
    }
    static hideAllLoadingSpinners() {
        document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner, .loading-overlay").forEach((spinner) => spinner.classList.add("hidden")),
            document.querySelectorAll(".collection.loading, .loading").forEach((el) => el.classList.remove("loading"));
    }
    static renderPage(searchParams, event, updateURLHash = !0) {
        if (FacetFiltersForm.isLoading) return;
        FacetFiltersForm.isLoading = !0;
        const loadingTimeout = setTimeout(() => {
            FacetFiltersForm.hideAllLoadingSpinners(), (FacetFiltersForm.isLoading = !1);
        }, 1e4);
        FacetFiltersForm.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm.getSections(),
            countContainer = document.getElementById("ProductCount"),
            countContainerDesktop = document.getElementById("ProductCountDesktop");
        document.querySelectorAll(".facets-container .loading__spinner, facet-filters-form .loading__spinner").forEach((spinner) => spinner.classList.remove("hidden")),
            document.getElementById("ProductGridContainer").querySelector(".collection").classList.add("loading"),
            countContainer && countContainer.classList.add("loading"),
            countContainerDesktop && countContainerDesktop.classList.add("loading");
        const cleanup = () => {
            clearTimeout(loadingTimeout), (FacetFiltersForm.isLoading = !1);
        };
        Promise.all(
            sections.map((section) => {
                const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`,
                    filterDataUrl = (element) => element.url === url;
                return FacetFiltersForm.filterData.some(filterDataUrl)
                    ? Promise.resolve(FacetFiltersForm.renderSectionFromCache(filterDataUrl, event))
                    : new Promise((resolve) => {
                          FacetFiltersForm.renderSectionFromFetch(url, event, resolve);
                      });
            })
        )
            .then(() => {
                updateURLHash && FacetFiltersForm.updateURLHash(searchParams);
            })
            .catch((error) => {
                console.error("Error rendering facets:", error);
            })
            .finally(() => {
                cleanup(), FacetFiltersForm.hideAllLoadingSpinners();
            });
    }
    static renderSectionFromFetch(url, event, resolve) {
        fetch(url)
            .then((response) => {
                if (!response.ok) throw new Error("Network response was not ok");
                return response.text();
            })
            .then((responseText) => {
                const html = responseText;
                (FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }]),
                    FacetFiltersForm.renderFilters(html, event),
                    FacetFiltersForm.renderProductGridContainer(html),
                    FacetFiltersForm.renderProductCount(html),
                    typeof initializeScrollAnimationTrigger == "function" && initializeScrollAnimationTrigger(html.innerHTML),
                    resolve && resolve();
            })
            .catch((error) => {
                console.error("Error fetching facets:", error), FacetFiltersForm.hideAllLoadingSpinners(), resolve && resolve();
            });
    }
    static renderSectionFromCache(filterDataUrl, event) {
        try {
            const cacheItem = FacetFiltersForm.filterData.find(filterDataUrl);
            if (!cacheItem || !cacheItem.html) throw new Error("Invalid cache data");
            const html = cacheItem.html;
            FacetFiltersForm.renderFilters(html, event),
                FacetFiltersForm.renderProductGridContainer(html),
                FacetFiltersForm.renderProductCount(html),
                typeof initializeScrollAnimationTrigger == "function" && initializeScrollAnimationTrigger(html.innerHTML);
        } catch (error) {
            console.error("Error rendering from cache:", error), FacetFiltersForm.hideAllLoadingSpinners();
        }
    }
  
static renderProductGridContainer(html) {
  try {
    const parser = new DOMParser();
    const parsedHTML = parser.parseFromString(html, "text/html");
    const newContainer = parsedHTML.getElementById("ProductGridContainer");

    if (!newContainer) throw new Error("ProductGridContainer not found in response");

    const productGrid = newContainer.querySelector("#product-grid");


    console.log('Window settings:', window.collectionSettings);
    console.log('Found product grid:', productGrid);
    console.log('Found products:', productGrid ? productGrid.querySelectorAll('li') : 'NO GRID');

    if (productGrid && window.collectionSettings?.removeProductsWithHideTag) {
      const productItems = Array.from(productGrid.querySelectorAll('li'));
      productItems.forEach((item) => {
        const tags = (item.getAttribute('data-product-tags') || '').toLowerCase();
        console.log('Checking product tags:', tags);
        if (tags.split(' ').includes('hide')) {
          console.log('Removing product because it has hide tag', item);
          item.remove();
        }
      });
    }

    const liveContainer = document.getElementById("ProductGridContainer");
    if (liveContainer) {
      liveContainer.innerHTML = newContainer.innerHTML;
    }

    document.querySelectorAll(".scroll-trigger").forEach((element) => {
      element.classList.add("scroll-trigger--cancel");
    });

    if (typeof initCustomDropdown === "function") {
      initCustomDropdown();
    }

    if (typeof window.attachAddToCartHandlers === "function") {
      window.attachAddToCartHandlers(document.getElementById('ProductGridContainer'));
    }

  } catch (error) {
    console.error("Error rendering product grid:", error);
    FacetFiltersForm.hideAllLoadingSpinners();
  }
}



    static renderProductCount(html) {
        try {
            const count = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount")?.innerHTML || "",
                container = document.getElementById("ProductCount"),
                containerDesktop = document.getElementById("ProductCountDesktop");
            container && ((container.innerHTML = count), container.classList.remove("loading")),
                containerDesktop && ((containerDesktop.innerHTML = count), containerDesktop.classList.remove("loading")),
                FacetFiltersForm.hideAllLoadingSpinners();
        } catch (error) {
            console.error("Error rendering product count:", error), FacetFiltersForm.hideAllLoadingSpinners();
        }
    }
    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, "text/html"),
            facetDetailsElementsFromFetch = parsedHTML.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter"),
            facetDetailsElementsFromDom = document.querySelectorAll("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter");
        Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
            Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id) || currentElement.remove();
        });
        const matchesId = (element) => {
                const jsFilter = event ? event.target.closest(".js-filter") : void 0;
                return jsFilter ? element.id === jsFilter.id : !1;
            },
            facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element)),
            countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);
        if (
            (facetsToRender.forEach((elementToRender, index) => {
                if (document.getElementById(elementToRender.id)) document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
                else {
                    if (index > 0) {
                        const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
                        if (elementToRender.className === previousElementClassName) {
                            document.getElementById(previousElementId).after(elementToRender);
                            return;
                        }
                    }
                    elementToRender.parentElement && document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
                }
            }),
            FacetFiltersForm.renderActiveFacets(parsedHTML),
            FacetFiltersForm.renderAdditionalElements(parsedHTML),
            countsToRender)
        ) {
            const closestJSFilterID = event.target.closest(".js-filter").id;
            if (closestJSFilterID) {
                FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter")), FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));
                const newFacetDetailsElement = document.getElementById(closestJSFilterID),
                    newElementSelector = newFacetDetailsElement.classList.contains("mobile-facets__details") ? ".mobile-facets__close-button" : ".facets__summary",
                    newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector),
                    isTextInput = event.target.getAttribute("type") === "text";
                newElementToActivate && !isTextInput && newElementToActivate.focus();
            }
        }
    }
    static renderActiveFacets(html) {
        [".active-facets-mobile", ".active-facets-desktop"].forEach((selector) => {
            const activeFacetsElement = html.querySelector(selector);
            activeFacetsElement && (document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML);
        }),
            FacetFiltersForm.toggleActiveFacets(!1);
    }
    static renderAdditionalElements(html) {
        [".mobile-facets__open", ".mobile-facets__count", ".sorting"].forEach((selector) => {
            html.querySelector(selector) && (document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML);
        });
        const mobileForm = document.getElementById("FacetFiltersFormMobile");
        if (mobileForm) {
            const menuDrawer = mobileForm.closest("menu-drawer");
            menuDrawer && typeof menuDrawer.bindEvents == "function" ? menuDrawer.bindEvents() : console.warn("Menu drawer or bindEvents method not found");
        }
    }
    static renderCounts(source, target) {
        const targetSummary = target.querySelector(".facets__summary"),
            sourceSummary = source.querySelector(".facets__summary");
        sourceSummary && targetSummary && (targetSummary.outerHTML = sourceSummary.outerHTML);
        const targetHeaderElement = target.querySelector(".facets__header"),
            sourceHeaderElement = source.querySelector(".facets__header");
        sourceHeaderElement && targetHeaderElement && (targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML);
        const targetWrapElement = target.querySelector(".facets-wrap"),
            sourceWrapElement = source.querySelector(".facets-wrap");
        sourceWrapElement &&
            targetWrapElement &&
            (target.querySelector("show-more-button .label-show-more.hidden") && sourceWrapElement.querySelectorAll(".facets__item.hidden").forEach((hiddenItem) => hiddenItem.classList.replace("hidden", "show-more-item")),
            (targetWrapElement.outerHTML = sourceWrapElement.outerHTML));
    }
    static renderMobileCounts(source, target) {
        const targetFacetsList = target.querySelector(".mobile-facets__list"),
            sourceFacetsList = source.querySelector(".mobile-facets__list");
        sourceFacetsList && targetFacetsList && (targetFacetsList.outerHTML = sourceFacetsList.outerHTML);
    }
    static updateURLHash(searchParams) {
        history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
    }
    static getSections() {
        return [{ section: document.getElementById("product-grid").dataset.id }];
    }
    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }
    onSubmitForm(searchParams, event) {
        FacetFiltersForm.renderPage(searchParams, event);
    }
    onSubmitHandler(event) {
        if ((event.preventDefault(), this.isLoading)) return;
        const sortFilterForms = document.querySelectorAll("facet-filters-form form");
        if (event.srcElement.className == "mobile-facets__checkbox") {
            const searchParams = this.createSearchParams(event.target.closest("form"));
            this.onSubmitForm(searchParams, event);
        } else {
            const forms = [],
                isMobile = event.target.closest("form").id === "FacetFiltersFormMobile";
            sortFilterForms.forEach((form) => {
                isMobile
                    ? form.id === "FacetFiltersFormMobile" && forms.push(this.createSearchParams(form))
                    : (form.id === "FacetSortForm" || form.id === "FacetFiltersForm" || form.id === "FacetSortDrawerForm") && forms.push(this.createSearchParams(form));
            }),
                this.onSubmitForm(forms.join("&"), event);
        }
    }
    onActiveFilterClick(event) {
        event.preventDefault(), FacetFiltersForm.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf("?") == -1 ? "" : event.currentTarget.href.slice(event.currentTarget.href.indexOf("?") + 1);
        FacetFiltersForm.renderPage(url);
    }
}
(FacetFiltersForm.filterData = []),
    (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
    (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
    (FacetFiltersForm.isLoading = !1),
    customElements.define("facet-filters-form", FacetFiltersForm),
    FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
    constructor() {
        super(),
            this.querySelectorAll("input").forEach((element) => {
                element.addEventListener("change", this.onRangeChange.bind(this)), element.addEventListener("keydown", this.onKeyDown.bind(this));
            }),
            this.setMinAndMaxValues();
    }
    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget), this.setMinAndMaxValues();
    }
    onKeyDown(event) {
        if (event.metaKey) return;
        const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
        event.key.match(pattern) || event.preventDefault();
    }
    setMinAndMaxValues() {
        const inputs = this.querySelectorAll("input"),
            minInput = inputs[0],
            maxInput = inputs[1];
        maxInput.value && minInput.setAttribute("data-max", maxInput.value),
            minInput.value && maxInput.setAttribute("data-min", minInput.value),
            minInput.value === "" && maxInput.setAttribute("data-min", 0),
            maxInput.value === "" && minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
    }
    adjustToValidValues(input) {
        const value = Number(input.value),
            min = Number(input.getAttribute("data-min")),
            max = Number(input.getAttribute("data-max"));
        value < min && (input.value = min), value > max && (input.value = max);
    }
}
customElements.define("price-range", PriceRange);
class FacetRemove extends HTMLElement {
    constructor() {
        super();
        const facetLink = this.querySelector("a");
        facetLink.setAttribute("role", "button"),
            facetLink.addEventListener("click", this.closeFilter.bind(this)),
            facetLink.addEventListener("keyup", (event) => {
                event.preventDefault(), event.code.toUpperCase() === "SPACE" && this.closeFilter(event);
            });
    }
    closeFilter(event) {
        event.preventDefault(), (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")).onActiveFilterClick(event);
    }
}
customElements.define("facet-remove", FacetRemove);
function initCustomDropdown() {
    const dropdown = document.getElementById("SortDropdown");
    if (!dropdown) return;
    const selected = dropdown.querySelector(".custom-dropdown__selected"),
        list = dropdown.querySelector(".custom-dropdown__list"),
        items = dropdown.querySelectorAll(".custom-dropdown__item"),
        hiddenInput = document.getElementById("SortBy"),
        arrowBtn = dropdown.querySelector(".btn-facet__sorting .svg-wrapper");
    selected?.removeEventListener("click", selected._listener),
        (selected._listener = function (event) {
            event.preventDefault(), dropdown.classList.toggle("open"), arrowBtn.classList.toggle("rotate");
        }),
        selected?.addEventListener("click", selected._listener),
        items.forEach((item) => {
            item.addEventListener("click", function () {
                (hiddenInput.value = item.getAttribute("data-value")),
                    (selected.querySelector("span:last-of-type").textContent = item.textContent.trim()),
                    document.querySelectorAll(".custom-dropdown__circle").forEach((circle) => circle.classList.remove("selected")),
                    item.querySelector(".custom-dropdown__circle").classList.add("selected");
                const url = new URL(window.location);
                url.searchParams.set("sort_by", item.getAttribute("data-value")),
                    window.history.pushState({}, "", url),
                    fetch(url, { cache: "no-store" })
                        .then((response) => response.text())
                        .then((html) => {
                            const newContent = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer");
                            newContent && (document.getElementById("ProductGridContainer").innerHTML = newContent.innerHTML),
                                selected.setAttribute("aria-expanded", "false"),
                                list.setAttribute("aria-hidden", "true"),
                                dropdown.classList.remove("open"),
                                arrowBtn.classList.remove("rotate"),
                                initCustomDropdown();
                        })
                        .catch((err) => console.error("Fetch error:", err));
            });
        }),
        document.addEventListener("click", function (e) {
            dropdown.contains(e.target) || (selected.setAttribute("aria-expanded", "false"), list.setAttribute("aria-hidden", "true"), dropdown.classList.remove("open"), arrowBtn.classList.remove("rotate"));
        });
}
document.addEventListener("DOMContentLoaded", function () {
    initCustomDropdown();
}),
    document.addEventListener("DOMContentLoaded", function () {
        const form = document.querySelector('form[id*="FacetFiltersForm"]');
        form &&
            form.addEventListener("change", (e) => {
                const target = e.target;
                if (target.name === "filter.p.tag") {
                    const selectedValue = target.value,
                        allLetterInputs = form.querySelectorAll('input[name="filter.p.tag"]');
                    /^[A-Z]$/.test(selectedValue) &&
                        (allLetterInputs.forEach((input) => {
                            input !== target && /^[A-Z]$/.test(input.value) && input.checked && (input.checked = !1);
                        }),
                        setTimeout(() => {
                            form.dispatchEvent(new Event("input", { bubbles: !0 }));
                        }, 100));
                }
            });
    });

